import { useMockableViewModel } from '@/hooks'
import { plugSessionDetailCollection } from '@/reducers/plugSessionCollections'
import { RequestStatus } from '@/request/types'
import { PlugSession } from '@/types/plugSessions'
import { MOCK_DATA } from './mockData'

type Args = {
  id: number
}

type ViewModel = {
  session: PlugSession | null
  isLoading: boolean
  notFound: boolean
}

function useViewModel({ id }: Args): ViewModel {
  // GET /api/plug_sessions/:id/ — scoped to the authenticated profile, so
  // another customer's session id fails and surfaces as notFound
  const { data, status } = plugSessionDetailCollection.useFetch(id)
  const session = data?.find((s) => s.id === id) ?? null

  return {
    session,
    isLoading:
      !session &&
      (status === RequestStatus.Loading || status === RequestStatus.Idle),
    notFound: status === RequestStatus.Failed,
  }
}

function useMockViewModel({ id }: Args): ViewModel {
  const session = MOCK_DATA.results.find((s) => s.id === id) ?? null
  return {
    session,
    isLoading: false,
    notFound: session === null,
  }
}

export default useMockableViewModel({ useViewModel, useMockViewModel })
